export default "__VITE_ASSET__CcUn5wpK__"